import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../services/notificationService";

interface notificationProps {
  page: number;
  pageSize: number;
  sort: any;
  status: string;
}
export const getAllNotifications = createAsyncThunk(
  "notifications/all",
  async (notificationProps: notificationProps, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, status } = notificationProps;

      const sortString = sort.direction === "asc" ? sort.key : `-${sort.key}`;

      const { data } = await API.getAllNotifications(
        page,
        pageSize,
        sortString,
        status,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAllNotificationsCount = createAsyncThunk(
  "notifications/count",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getNotificationCount();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const readNotification = createAsyncThunk(
  "notifications/read",
  async (notificationId: string, { rejectWithValue }) => {
    try {
      const { data } = await API.readNotification(notificationId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteUserNotification = createAsyncThunk(
  "notifications/delete",
  async (notificationId: string, { rejectWithValue }) => {
    try {
      const { data } = await API.deleteNotification(notificationId);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const readAllNotifications = createAsyncThunk(
  "notifications/read/all",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.readAllNotifications();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
